module.exports = __webpack_public_path__ + "static/media/NotasFiscais7.29974cdb.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancNotasFiscais/NotasFiscais7.png
// module id = 2138
// module chunks = 0